var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-right"),React.createElement("path",{"d":"M239.172 237.708v0l-234.294-234.457c-1.426-1.158-3.022-2.236-4.71-3.167l-0.168-0.085v28.128l227.791 227.791-18.373 18.21-209.417 209.743v28.129c1.859-0.935 3.461-2.017 4.906-3.276l-0.028 0.024 252.341-252.505z","key":1})]);
}

ArrowRight.defaultProps = {"version":"1.1","width":"258","height":"512","viewBox":"0 0 258 512"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
